import { render, staticRenderFns } from "./express-footer.vue?vue&type=template&id=1fbead45&scoped=true"
import script from "./express-footer.vue?vue&type=script&lang=js"
export * from "./express-footer.vue?vue&type=script&lang=js"
import style0 from "./express-footer.vue?vue&type=style&index=0&id=1fbead45&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fbead45",
  null
  
)

export default component.exports